<template>
  <div>
    <AppInfoSMSSendDeliveryDetails
      :detalhesEnvioEntregaSMS="detalhesEnvioEntregaSMS"
    />
  </div>
</template>
<script>
import { Tabs, Tab } from 'uiv'
import AppInfoSMSSendDeliveryDetails from './InfoSMSSendDeliveryDetails'
export default {
  name: 'AppInfoSMS',

  props: {
    detalhesEnvioEntregaSMS: {
      type: Object
    }
  },

  components: {
    Tabs,
    Tab,
    AppInfoSMSSendDeliveryDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-sms/InfoSMS.vue